import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPaywall2DocumentReady = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <circle cx={12} cy={12} r={12} fill="#009E5E" />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m8.5 12.708 2.1 2.125 4.9-5.666"
    />
  </svg>
);
export default SvgPaywall2DocumentReady;
